import React from "react";
import InputAccountBank from "../../components/InputAccountBank";
import TextInfo from "../../components/TextInfo";
import { Search, Print } from "@material-ui/icons/";
import { Typography } from "@material-ui/core";
import ButtonTypeName from "../../components/ButtonTypeName";
import useStyles from "./styles";
import { convertDate } from "../../helper/convertDate";
import { addMascaraReal } from "../../helper/utils";

export default function FindDAMHeader({
  isFindDAMPage,
  getDAMTyped,
  getDAMs,
  handleReissue,
  handlePrintReport,
  infoDAM,
  isLoading,
}) {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.inputsBox}>
        <div>
          {infoDAM && Object.keys(infoDAM).length !== 0 && (
            <div className={infoDAM && classes.infoDAM}>
              <>
                <Typography color="textSecondary" variant="h6">
                  DADOS DO DAM
                </Typography>
                <div style={{ display: "flex", gap: 20 }}>
                  <div className={classes.infoColumns}>
                    <TextInfo
                      label="Data de Emissão:"
                      value={convertDate(infoDAM?.DataSolicitacao)}
                      loading={isLoading}
                    />
                    <TextInfo
                      label="Valor Total:"
                      value={addMascaraReal(infoDAM?.Valor)}
                      loading={isLoading}
                    />
                  </div>
                  <div className={classes.infoColumns}>
                    <TextInfo
                      label="Data de Vencimento:"
                      value={convertDate(infoDAM?.DataVencimento)}
                      loading={isLoading}
                    />
                    <TextInfo
                      label="Quantidade de Débitos:"
                      value={infoDAM?.Debitos?.length}
                      loading={isLoading}
                    />
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
        <div className={classes.groupButtons}>
          <div className={classes.textFieldParent}>
            <InputAccountBank
              isFindDAMPage={isFindDAMPage}
              inputType={5}
              getDAMTyped={getDAMTyped}
            />
            <div onClick={getDAMs} className={classes.findIcon}>
              <Search style={{ height: "30px" }} />
            </div>
          </div>
          <div>
            <div onClick={handlePrintReport}>
              <span className={classes.printReportText}>
                <Print style={{ paddingRight: "4px" }} /> Imprimir relatório
              </span>
            </div>
            <div onClick={handleReissue}>
              <ButtonTypeName typeButton={10} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
